<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        small
        icon
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Benefit In Kind"
      text="Update Benefit In Kind"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-autocomplete
              v-model="localBenefitInKind.benefit_in_kind_id"
              v-validate="'required'"
              :items="benefitInKinds"
              item-text="name"
              item-value="id"
              label="Benefit In Kind"
              :error-messages="errors.collect('benefit_in_kind_id')"
              data-vv-name="benefit_in_kind_id"  
              data-vv-as="benefit in kind"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localBenefitInKind.amount"
              v-money="money"
              label="Amount"
              prefix="RM"
              outlined
            />
          </v-col>
          
          <v-col cols="12">
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDateDisplay"
                  v-validate="'required'"
                  :error-messages="errors.collect('startDateDisplay')"
                  data-vv-name="startDateDisplay"
                  data-vv-as="start date"
                  label="Start date"
                  outlined
                  readonly
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localBenefitInKind.start_date"
                no-title
                :min="companyEmployeeStartDate"
                @input="startDateMenu = false"
              />
            </v-menu> 
          </v-col>

          <v-col
            cols="12"
          >
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDateDisplay"
                  data-vv-name="endDateDisplay"
                  data-vv-as="end date"
                  label="End date"
                  readonly
                  outlined
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localBenefitInKind.end_date"
                no-title
                :min="localBenefitInKind.start_date"
                @input="endDateMenu = false"
              />
            </v-menu> 
          </v-col> 
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="hrissecondary"
          class="px-10 white--text"
          :loading="progressing"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    directives: { money: VMoney },
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      benefitInKind: {
        type: Object,
        default: null,
        required: true,
      },
      companyEmployeeStartDate: {
        type: String,
        required: true,
      },
    },

    data () {
      return {
        dialog: false,
        progressing: false,
        startDateMenu: false,
        endDateMenu: false,
        localBenefitInKind: null,
        benefitInKinds: [],
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },

    computed: {
      startDateDisplay () {
        return this.localBenefitInKind.start_date ? this.$moment(this.localBenefitInKind.start_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : '' 
      },
      endDateDisplay () {
        return this.localBenefitInKind.end_date ? this.$moment(this.localBenefitInKind.end_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },

    watch: {
      dialog: function (val) {
        if (!val) return

        this.$api.benefitInKinds().list('?filter[type]=bik')
          .then(res => {
            this.benefitInKinds = _.orderBy(res.data, ['name'], ['asc'])

            this.loading = false
          })

        this.localBenefitInKind = { ...this.benefitInKind }

        if (this.localBenefitInKind.amount) this.localBenefitInKind.amount = (Math.round((this.localBenefitInKind.amount / 100) * 100) / 100).toFixed(2)
      },
    },

    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            
            this.$api.companyEmployeeBenefitInKinds().update(this.localBenefitInKind.id, this.prepareFormData())
              .then(res => {
                this.$emit('updated')
                this.$snack({ message: res.data.status })

                this.dialog = false
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return { 
          start_date: this.localBenefitInKind.start_date,
          benefit_in_kind_id: this.localBenefitInKind.benefit_in_kind_id,
          amount: this.localBenefitInKind.amount.toString().replaceAll(',', '') * 100,
          end_date: this.localBenefitInKind.end_date,
        }
      },
    },
  }
</script>

<style scoped>
.disabled-background >>> .v-input__slot{
  background: #f0f0f0
}
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  padding-right:5px;
  background-color:white;
}
</style>
